const addressAdditionalOption = { value: 0, label: 'Enter address manually' };

export default addressAdditionalOption;
